define([
    'lodash',
    'localSiteSerializer/plugins/plugins',
    'localSiteSerializer/encoder'
], function (_, allPlugins, encoder) {
    'use strict';
    const documentSchemaVersion = '1.0';

    class DecodeError extends Error {
        constructor(err, path) {
            super(err.message);
            this.name = 'DecodeError';
            this.path = path;
            this.stack = err.stack;
        }
    }

    return ({plugins = Object.values(allPlugins), encodeWhenSerializing = true} = {}) => {
        const pluginsToRun = Object.values(plugins);
        const serialize = siteModel => {
            const serialized = Object.assign({}, pluginsToRun.reduce((accumulator, {serialize: pluginSerialize}) =>
                _.merge(accumulator, pluginSerialize(siteModel))
            , {}), {documentSchemaVersion});
            return encodeWhenSerializing ? encode(serialized) : serialized;
        };

        const deserialize = payload => {
            const decodedPayload = encodeWhenSerializing ? decode(payload) : payload;
            return _(plugins).reverse().reduce((accumulator, {deserialize: pluginDeserialize}) =>
                _.merge(accumulator, pluginDeserialize(decodedPayload))
            , {});
        };

        const encode = (decodedPayload, encodeFn = encoder.encode) => {
            const encodedPayload = _.cloneDeep(decodedPayload);
            return pluginsToRun.reduce((accumulator, plugin) => {
                plugin.getEncryptedPaths(encodedPayload).forEach(path => {
                    const value = _.get(decodedPayload, path);
                    try {
                        if (value) {_.set(accumulator, path, encodeFn(value));}
                    } catch (error) {
                        throw new DecodeError(error, path);
                    }
                });
                return accumulator;
            }, encodedPayload);
        };

        const decode = (encodedPayload, decodeFn = encoder.decode) => encode(encodedPayload, decodeFn);

        return {
            serialize,
            deserialize,
            encode,
            decode
        };
    };
});
